import { createSelector } from 'reselect';

const cottageSelector = createSelector(
  (state) => state.cottage,
  (cottage) => cottage,
);

export const isFetching = createSelector(
  cottageSelector,
  (cottage) => cottage.isFetching,
);

export const data = createSelector(
  cottageSelector,
  (cottage) => cottage.data,
);

export const pristineSelector = createSelector(cottageSelector, (c) => c.pristine);

export const initialValues = createSelector(
  data,
  (dt) => {
    const amenities = {};
    const images = {};
    const cities = dt.cities ? dt.cities.map((value) => ({ label: value, value })) : [];

    if (dt.amenities) {
      dt.amenities.forEach(({ key, ...other }) => {
        amenities[key] = { ...other, checked: true };
      });
    }

    if (dt.images) {
      dt.images.forEach((image, i) => {
        images[i + 1] = { ...image, weight: i };
      });
    }

    return {
      ...dt,
      amenities,
      cities,
      images,
    };
  },
);

export const updatingDialogs = createSelector(
  cottageSelector,
  (cottage) => cottage.updatingDialogs,
);

export const error = createSelector(
  cottageSelector,
  (cottage) => cottage.error,
);

export const lastMinuteDeals = createSelector(
  cottageSelector,
  (cottage) => cottage.lastMinuteDeals,
);

export const lastMinuteDealsData = createSelector(
  lastMinuteDeals,
  (lastMinute) => lastMinute.data,
);

export const lastMinuteCreateDeleteStatus = createSelector(lastMinuteDeals, (lm) => ({
  created: lm.created,
  deleted: lm.deleted,
}));

export const lastMinuteDealsIsLoading = createSelector(
  lastMinuteDeals,
  (lastMinute) => lastMinute.isLoading,
);

export const coreId = createSelector(cottageSelector, (cottage) => cottage.coreId);

export const updateSuccess = createSelector(cottageSelector, (c) => c.success);

export default cottageSelector;
